import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IPark } from '@/api/routes/parks/types';
import smartSort from '@/utils/smartSort';

import { fetchParks } from './actionCreators';

interface InitialState {
  parks: IPark [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  parks: [],
  isLoading: false,
  error: '',
};

export const parksSlice = createSlice({
  name: 'parks',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchParks.fulfilled.type]: (state, action: PayloadAction<IPark []>) => {
      state.isLoading = false;
      state.error = '';
      state.parks = action.payload.sort((a, b) => smartSort(a.name, b.name));
    },
    [fetchParks.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchParks.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default parksSlice.reducer;
